var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import cs from '../_util/classNames';
import { AnchorContext } from './index';
import { NOOP } from '../_util/constant';
import { ConfigConsumer } from '../ConfigProvider';
import { isString } from '../_util/is';
var LinkComponent = /** @class */ (function (_super) {
    __extends(LinkComponent, _super);
    function LinkComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderLink = function (_a) {
            var getPrefixCls = _a.getPrefixCls;
            var _b = _this.props, href = _b.href, title = _b.title, className = _b.className, style = _b.style, children = _b.children, currentLink = _b.currentLink, onLinkClick = _b.onLinkClick;
            var prefixCls = getPrefixCls('anchor-link');
            return (React.createElement("li", { className: cs(prefixCls, className), style: style, key: href },
                React.createElement("a", { title: isString(title) ? title : '', className: cs({ 'is-active': currentLink === href }), href: href, "data-href": href, onClick: function (e) {
                        onLinkClick && onLinkClick(e, href);
                    } }, title),
                children && (React.createElement("div", { className: prefixCls + "-inner" }, React.Children.map(children, function (item) {
                    return item.props.isAnchorLink && item;
                })))));
        };
        return _this;
    }
    LinkComponent.prototype.componentWillMount = function () {
        this.props.addLink && this.props.addLink(this.props.href, null);
    };
    LinkComponent.prototype.componentDidMount = function () {
        this.props.addLink && this.props.addLink(this.props.href, findDOMNode(this));
    };
    LinkComponent.prototype.componentWillUnmount = function () {
        this.props.removeLink && this.props.removeLink(this.props.href);
    };
    LinkComponent.prototype.componentDidUpdate = function (_a) {
        var prevHref = _a.href;
        var href = this.props.href;
        if (prevHref !== href) {
            this.componentWillUnmount();
            this.componentDidMount();
        }
    };
    LinkComponent.prototype.render = function () {
        return React.createElement(ConfigConsumer, null, this.renderLink);
    };
    return LinkComponent;
}(PureComponent));
var Link = /** @class */ (function (_super) {
    __extends(Link, _super);
    function Link() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Link.prototype.render = function () {
        var _this = this;
        return (React.createElement(AnchorContext.Consumer, null, function (anchorProps) { return React.createElement(LinkComponent, __assign({}, _this.props, anchorProps, { isAnchorLink: true })); }));
    };
    Link.propTypes = {
        className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        style: PropTypes.object,
        href: PropTypes.string,
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        isAnchorLink: PropTypes.bool,
        currentLink: PropTypes.string,
        addLink: NOOP,
        removeLink: NOOP,
        onLinkClick: NOOP,
    };
    Link.defaultProps = {
        isAnchorLink: true,
        href: '#',
        addLink: NOOP,
        removeLink: NOOP,
        onLinkClick: NOOP,
    };
    return Link;
}(PureComponent));
export default Link;
